// extracted by mini-css-extract-plugin
export default {"button":"LoginButton_button_n1Puz"};